import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { GetSeatmapsEffect } from './get-seatmaps.effect';
import { getSeatmapsReducer } from './get-seatmaps.reducer';
import { GET_SEATMAPS_STORE_NAME, GetSeatmapsState } from './get-seatmaps.state';

/** Token of the GetSeatmaps reducer */
export const GET_SEATMAPS_REDUCER_TOKEN = new InjectionToken<ActionReducer<GetSeatmapsState, Action>>(
  'Feature GetSeatmaps Reducer'
);

/** Provide default reducer for GetSeatmaps store */
export function getDefaultGetSeatmapsReducer() {
  return getSeatmapsReducer;
}

@NgModule({
  imports: [
    StoreModule.forFeature(GET_SEATMAPS_STORE_NAME, GET_SEATMAPS_REDUCER_TOKEN),
    EffectsModule.forFeature([GetSeatmapsEffect]),
  ],
  providers: [{ provide: GET_SEATMAPS_REDUCER_TOKEN, useFactory: getDefaultGetSeatmapsReducer }],
})
export class GetSeatmapsStoreModule {
  public static forRoot<T extends GetSeatmapsState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<GetSeatmapsStoreModule> {
    return {
      ngModule: GetSeatmapsStoreModule,
      providers: [{ provide: GET_SEATMAPS_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
